import { useContext, useCallback, useState, useEffect } from 'react'

import { Button, Box } from '@material-ui/core'

import { MultiSectionDialog } from '@scoir/modals'
import { CONTENT_TYPES } from '@scoir/college-content'

import ContentModalContext from '../ContentModalProvider/Context'
import ContentManagementContext from '../../../ContentManagementProvider/Context'
import { FIELD_NAMES } from '../components/constants'

import Details from './Details/index'
import Type from './Type'
import Audience from './Audience'
import Academics from './Academics'
import Admissions from './Admissions'
import Financial from './Cost_Aid'
import ContentType from './ContentType'
import HiddenSwitch from './HiddenSwitch'
import ModalError from '../../ModalError'

const ContentEditModal = () => {
  const {
    type,
    show,
    item,
    onHideModal,
    onDeleteItem,
    onSaveItem,
    isEditing,
    validation,
    selectedAcademicFocuses,
    selectedCategories,
    exceed5Tags,
    setExceed5Tags,
  } = useContext(ContentModalContext)
  const { saveContentLoading, saveContentError } = useContext(ContentManagementContext)
  const isPostContent = type !== CONTENT_TYPES.PROGRAMS && type !== CONTENT_TYPES.SESSIONS
  const exceed5TagsError = !isPostContent && exceed5Tags
  const imageError = isPostContent && !item[FIELD_NAMES.IMAGE_URL]
  const canSave = !saveContentLoading && !validation.hasErrors && !exceed5TagsError && !imageError
  const [enforceFocus, setEnforceFocus] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)

  const isPost = type !== CONTENT_TYPES.PROGRAMS && type !== CONTENT_TYPES.SESSIONS

  const headerTextType = () => {
    switch (type) {
      case CONTENT_TYPES.SESSIONS:
        return 'Event'
      case CONTENT_TYPES.PROGRAMS:
        return 'Program'
      default:
        return 'Post'
    }
  }

  const headerText = `${isEditing ? 'Edit' : 'New'} ${headerTextType()}`

  useEffect(() => {
    const categoriesLength = selectedCategories?.length || 0
    const academicFocusesLength = selectedAcademicFocuses?.length || 0
    setExceed5Tags(categoriesLength + academicFocusesLength > 5)
  }, [selectedAcademicFocuses?.length, selectedCategories?.length, setExceed5Tags])

  const toggleEnforceFocus = useCallback(() => {
    setEnforceFocus(!enforceFocus)
  }, [enforceFocus])

  return (
    <MultiSectionDialog
      open={show}
      onClose={onHideModal}
      scroll="paper"
      headerText={headerText}
      disableEnforceFocus={enforceFocus}
      headerChildren={<HiddenSwitch />}
    >
      <MultiSectionDialog.Body>
        <Box
          display="flex"
          flexDirection="column"
          gridGap={24}
        >
          <Details onToggleEnforceFocus={toggleEnforceFocus} />
          {isPost ? <ContentType /> : <Type />}
          {(type === CONTENT_TYPES.SESSIONS || isPost) && <Audience />}
          {type === CONTENT_TYPES.PROGRAMS && (
            <>
              <Academics />
              <Admissions />
              <Financial />
            </>
          )}
        </Box>
      </MultiSectionDialog.Body>
      <MultiSectionDialog.Footer>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
        >
          {saveContentError && <ModalError />}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="text"
              color="primary"
              onClick={onHideModal}
            >
              Cancel
            </Button>
            <Box
              display="flex"
              gridGap={8}
            >
              {isEditing && !confirmDelete && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setConfirmDelete(true)}
                >
                  Delete
                </Button>
              )}
              {isEditing && confirmDelete && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={onDeleteItem}
                >
                  Confirm Delete
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                disabled={!canSave}
                onClick={onSaveItem}
              >
                {item[FIELD_NAMES.IS_HIDDEN] ? 'Save as Hidden' : 'Save & Publish'}
              </Button>
            </Box>
          </Box>
        </Box>
      </MultiSectionDialog.Footer>
    </MultiSectionDialog>
  )
}

export default ContentEditModal
